export default __webpack_public_path__ + "static/media/Believer's Harness of the Bloody Stone.8e0c25de.jpg";